// src/components/Navbar.jsx
import "../../../src/assets/css/home.css";
import Banner from "./Banner";
import WhyChooseMeera from "./WhyChoose";
import Certifications from "./Certifications";
import Advantages from "./Advantages";
import Quality from "./Quality";
import ReelSection from "./Feed";
import UpcomingEvents from "./UpcomingEvents";
import TrendyBlog from "./TrendyBlog";
//import DifferenceSection from "../AboutUs/DifferenceSection";

export default function Home() {
    document.title = "Meera Jewellery House";
    return (
        <>
            <div style={{ overflow: 'hidden', background: "#fff" }}>                
                <Banner />
                {/*<div className="manufacture">*/}
                {/*    <DifferenceSection />*/}
                {/*</div>*/}
                <WhyChooseMeera />
                <Certifications />
                <Advantages />
                <Quality />
                <TrendyBlog />
                <UpcomingEvents />
                <ReelSection />
            </div>
        </>
    );
}
